import React from 'react';

import { useEnhancedTablesEnabled } from '@campaign-manager/feature/hook/useEnhancedTablesEnabled';

import EnhancedTable from '../EnhancedTable';
import Table from '../Table';

/**
 * Table component that automatically uses EnhancedTable when the feature is enabled.
 * Falls back to regular Table when the feature is disabled.
 *
 * The tableId prop is required when enhanced tables are enabled for settings persistence.
 */
export default function TableWithFeatureFlag<T>(props: any) {
  const enhancedTablesEnabled = useEnhancedTablesEnabled();

  if (enhancedTablesEnabled) {
    // EnhancedTable requires a tableId for persistence
    if (!props.tableId) {
      console.warn('EnhancedTable requires a tableId prop for settings persistence');
    }

    return <EnhancedTable<T> {...props} />;
  }

  // Regular table doesn't need tableId
  const { tableId, ...regularTableProps } = props;
  return <Table<T> {...regularTableProps} />;
}
